import { KnownPlanningTaskFacts } from './known-planning-task-facts.interface';
import {
  PLANNING_TASK_TYPE,
  PlanningTask,
  PlanningTaskType,
  StartedPlanningTask,
} from '@features/planning/util-planning-task';

/** A tracked task from the backend's task DTO; its references name the schedule group among others (#5182). */
export function toPlanningTask(
  dto: StartedPlanningTask,
  known: KnownPlanningTaskFacts = {},
): PlanningTask {
  return {
    asyncTaskUId: dto.uId,
    type: toPlanningTaskType(dto.type),
    planName: planNameOf(dto.name) || known.planName || '',
    referenceUIds: referenceUIdsOf(dto, known.scheduleGroupUId),
    progress: null,
    outcome: null,
    lastLogCreated: null,
    seenLogKeys: [],
  };
}

/** The UIds a task's message references, plus the schedule group the app started it for. */
function referenceUIdsOf(dto: StartedPlanningTask, scheduleGroupUId?: string): string[] {
  const referenceUIds = new Set(
    (dto.message?.references ?? [])
      .map((reference) => reference.data?.referenceUId)
      .filter((uId): uId is string => !!uId),
  );
  if (scheduleGroupUId) referenceUIds.add(scheduleGroupUId);
  return [...referenceUIds];
}

/** `Planung abschließen: Urlaubsplanung 2027` names the planning after the colon. */
export function planNameOf(taskName: string | null | undefined): string {
  const name = taskName ?? '';
  const separator = name.indexOf(':');
  return (separator >= 0 ? name.slice(separator + 1) : name).trim();
}

function toPlanningTaskType(type: string | null | undefined): PlanningTaskType | null {
  const known = Object.values(PLANNING_TASK_TYPE).find((candidate) => candidate === type);
  return known ?? null;
}
